var map = {
	"./404.svg": "./src/icons/svg/404.svg",
	"./bug.svg": "./src/icons/svg/bug.svg",
	"./car.svg": "./src/icons/svg/car.svg",
	"./chart.svg": "./src/icons/svg/chart.svg",
	"./clipboard.svg": "./src/icons/svg/clipboard.svg",
	"./component.svg": "./src/icons/svg/component.svg",
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./documentation.svg": "./src/icons/svg/documentation.svg",
	"./down.svg": "./src/icons/svg/down.svg",
	"./drag.svg": "./src/icons/svg/drag.svg",
	"./edit.svg": "./src/icons/svg/edit.svg",
	"./education.svg": "./src/icons/svg/education.svg",
	"./email.svg": "./src/icons/svg/email.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./excel.svg": "./src/icons/svg/excel.svg",
	"./exit-fullscreen.svg": "./src/icons/svg/exit-fullscreen.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./eye_close.svg": "./src/icons/svg/eye_close.svg",
	"./eye_open.svg": "./src/icons/svg/eye_open.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./fullscreen.svg": "./src/icons/svg/fullscreen.svg",
	"./guide.svg": "./src/icons/svg/guide.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./international.svg": "./src/icons/svg/international.svg",
	"./invoice.svg": "./src/icons/svg/invoice.svg",
	"./language.svg": "./src/icons/svg/language.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./list.svg": "./src/icons/svg/list.svg",
	"./lock.svg": "./src/icons/svg/lock.svg",
	"./message.svg": "./src/icons/svg/message.svg",
	"./money.svg": "./src/icons/svg/money.svg",
	"./more_info.svg": "./src/icons/svg/more_info.svg",
	"./move.svg": "./src/icons/svg/move.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./pdf.svg": "./src/icons/svg/pdf.svg",
	"./people.svg": "./src/icons/svg/people.svg",
	"./peoples.svg": "./src/icons/svg/peoples.svg",
	"./plus.svg": "./src/icons/svg/plus.svg",
	"./qq.svg": "./src/icons/svg/qq.svg",
	"./search.svg": "./src/icons/svg/search.svg",
	"./shopping.svg": "./src/icons/svg/shopping.svg",
	"./shuaxin.svg": "./src/icons/svg/shuaxin.svg",
	"./size.svg": "./src/icons/svg/size.svg",
	"./skill.svg": "./src/icons/svg/skill.svg",
	"./star.svg": "./src/icons/svg/star.svg",
	"./tab.svg": "./src/icons/svg/tab.svg",
	"./table-setting.svg": "./src/icons/svg/table-setting.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./task.svg": "./src/icons/svg/task.svg",
	"./theme.svg": "./src/icons/svg/theme.svg",
	"./tree-table.svg": "./src/icons/svg/tree-table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./up.svg": "./src/icons/svg/up.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./wechat.svg": "./src/icons/svg/wechat.svg",
	"./zip.svg": "./src/icons/svg/zip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";